/* YMIR — global behavior */
(function () {
  'use strict';

  /* ---- Intro stamp: play once per session ---- */
  var intro = document.getElementById('YmirIntro');
  if (intro) {
    var seen = false;
    try { seen = sessionStorage.getItem('ymirIntroSeen') === '1'; } catch (e) {}
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seen || reduced) {
      document.body.classList.add('intro-done');
    } else {
      try { sessionStorage.setItem('ymirIntroSeen', '1'); } catch (e) {}
      setTimeout(function () { document.body.classList.add('intro-done'); }, 2400);
    }
  }

  /* ---- Mobile menu ---- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('MobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- Product: quantity steppers (product + cart lines) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty], [data-line-qty]');
    if (!btn) return;
    var box = btn.closest('.qty-box');
    var input = box && box.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty') || btn.getAttribute('data-line-qty'), 10) || 0;
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Product: gallery thumbs ---- */
  var mainImage = document.getElementById('ProductMainImage');
  if (mainImage) {
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---- Product: variant matching ---- */
  var variantsScript = document.querySelector('[data-variants]');
  var variantInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var addBtn = document.getElementById('AddToCart');

  if (variantsScript && variantInput) {
    var variants, priceMap = {};
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
    var pricesScript = document.querySelector('[data-variant-prices]');
    if (pricesScript) {
      try { priceMap = JSON.parse(pricesScript.textContent); } catch (e) {}
    }

    var syncVariant = function () {
      var selected = [];
      document.querySelectorAll('.variant-pills').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      if (!selected.length) return;

      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });

      if (match) {
        variantInput.value = match.id;
        if (priceEl && priceMap[match.id]) priceEl.textContent = priceMap[match.id];
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.firstChild.textContent = match.available ? 'ADD TO CART ' : 'SOLD OUT ';
        }
      } else if (addBtn) {
        addBtn.disabled = true;
      }
    };

    document.querySelectorAll('.variant-pills input').forEach(function (input) {
      input.addEventListener('change', syncVariant);
    });
    syncVariant();
  }

  /* ---- Ticker: ensure track is long enough to loop seamlessly ---- */
  document.querySelectorAll('[data-ticker]').forEach(function (track) {
    var clone = track.querySelector('span');
    if (clone) track.appendChild(clone.cloneNode(true));
  });
})();
